import React from 'react';
import Footer from 'rc-footer';
import { BackTop, Divider } from 'antd';

function AppFooter() {
  return (
    <div className="container-fluid">
      <div className="footer">
        <div className="logo">
          <a href="">Chaperone API Hub</a>
        </div>
        <Divider/>
        <div className="copyright"> Product of <a href='https://chaperone.co.ls'><b>Chaperone Ltd</b></a>. All Rights Reserved &copy; {new Date().getFullYear()}</div>
        <BackTop>
          <div className="goTop"><i className="fas fa-arrow-circle-up"></i></div>
        </BackTop>
      </div>
    </div>
  );
}

export default AppFooter;